import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';

import { useMediaQuery } from '@/hooks/useMediaQuery';

import styles from './AppLayout.module.css';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

/** Matches the breakpoint in Sidebar.module.css where the sidebar turns into a drawer. */
const DRAWER_QUERY = '(width < 64rem)';

/** The staff app: sidebar, top bar and the current screen. */
export function AppLayout() {
  const isNarrow = useMediaQuery(DRAWER_QUERY);
  const [menuOpen, setMenuOpen] = useState(false);
  const drawerOpen = isNarrow && menuOpen;

  useEffect(() => {
    if (!drawerOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setMenuOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [drawerOpen]);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className={styles.shell}>
      <Sidebar open={drawerOpen} onClose={closeMenu} />
      {drawerOpen && <div className={styles.backdrop} aria-hidden="true" onClick={closeMenu} />}

      {/* While the drawer is open the page behind it can't be reached by keyboard or reader. */}
      <div className={styles.main} inert={drawerOpen}>
        <TopBar
          onOpenMenu={() => {
            setMenuOpen(true);
          }}
        />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
